
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import functionUncurryThis from './function-uncurry-this.js';

var uncurryThis = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis({}.isPrototypeOf);

export { objectIsPrototypeOf as default };
//# sourceMappingURL=object-is-prototype-of.js.map
